import { Injectable, inject } from '@angular/core';
import { RestApiService } from '@core/services/rest-api.service';
import { Entity } from '@shared/constants/entity';
import { UserLogEventType } from '@shared/constants/user-log-event-type';

@Injectable({ providedIn: 'root' })
export class UserLogEventService {
  private api = inject(RestApiService);

  logEvent(eventType: UserLogEventType): void {
    this.api
      .upsert(Entity.UserEventLog, 0, { EventType: eventType })
      .subscribe();
  }
}
